import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
const portalId = 'emote-selector-portal';
const EmoteSelectorPortal = ({ children })=>{
    const containerRef = useRef(document.getElementById(portalId));
    if (!containerRef.current) {
        const el = document.createElement('div');
        el.id = portalId;
        document.body.appendChild(el);
        containerRef.current = el;
    }
    return /*#__PURE__*/ ReactDOM.createPortal(children, containerRef.current);
};
EmoteSelectorPortal.displayName = 'EmoteSelectorPortal';
export default EmoteSelectorPortal;

//# sourceMappingURL=Portal.js.map